import gql from 'graphql-tag';

export default gql`
  query CampsiteSortType {
    campsiteSortType @client
  }
`;
